import React from 'react'
import ReactModal from 'react-modal'
import {
  ModalHeader,
  ModalWrapper,
  ModalFooter,
  ModalContent,
  ModalButton,
  customStyles,
} from 'src/components/shared/modal-view'

interface ProcessingModalProps {
  open: boolean
  onConfirm: () => void
  onClose: () => void
}

export const ProcessingModal: React.FC<ProcessingModalProps> = ({ open, onClose, onConfirm }) => {
  ReactModal.setAppElement('#root')
  return (
    <ReactModal isOpen={open} onRequestClose={onClose} style={customStyles} shouldCloseOnEsc>
      <ModalWrapper>
        <ModalHeader>Процессинг каналов</ModalHeader>
        <ModalContent>
          Вы уверены что хотите сделать процессинг Slack каналов. В slack будут созданы соответствующие каналы, а в них
          будут добавлены студенты и менторы
        </ModalContent>
        <ModalFooter>
          <ModalButton action="secondary" onClick={onConfirm}>
            Подтвердить
          </ModalButton>
          <ModalButton action="secondary" onClick={onClose}>
            Закрыть
          </ModalButton>
        </ModalFooter>
      </ModalWrapper>
    </ReactModal>
  )
}
